"use client";

import { useState } from "react";
import Sidebar from "../common/Sidebar";
import Header from "../common/Header";
import { Send, Clock3 } from "lucide-react";
import PageWrapper from "../../../components/admin/common/PageWrapper";
import EmailMetaApiForm from "./EmailMetaApiForm";
import { EmailScheduleList } from "./EmailScheduleList";

const TABS = [
  {
    key: "send",
    label: "Send Email",
    icon: <Send className="w-4 h-4 mr-1 text-blue-600" />,
  },
  {
    key: "schedule",
    label: "Email",
    icon: <Clock3 className="w-4 h-4 mr-1 text-emerald-600" />,
  },
];

const EmailSendScheduleManager = ({
  templates,
  groups,
  schedule,
  refreshSchedule,
  hasMore,
  totalCount,
  onLoadMore,
  pageIndex,
}) => {
  const [activeTab, setActiveTab] = useState("send");

  return (
    <div className="flex h-screen p-4 gap-4 bg-white overflow-hidden">
      <div className="h-full">
        <div className="sticky top-0 h-screen text-white">
          <Sidebar />
        </div>
      </div>

      <div className="flex-1 h-full bg-[#F3EFFF] rounded-[27px] overflow-hidden">
        <PageWrapper>
          <div className="flex flex-col h-full">
            <div className="flex-1 p-4 overflow-y-auto">
              <Header
                title={"Send / Schedule Mail"}
                desc="Here you can send message now or later"
              />

              <div className="mt-6 w-full">
                <div className="flex w-[475px] space-x-4 border-b-2 border-gray-200">
                  {TABS.map((tab) => {
                    const isActive = activeTab === tab.key;
                    return (
                      <div
                        key={tab.key}
                        onClick={() => setActiveTab(tab.key)}
                        className={`relative flex items-center px-4 py-2 text-sm font-medium transition-colors duration-200 ${
                          isActive ? "text-blue" : "text-black"
                        }`}
                      >
                        {tab.icon}
                        {tab.label}
                        {isActive && (
                          <span className="absolute -bottom-[2px] left-0 right-0 h-0.5 bg-blue rounded-full" />
                        )}
                      </div>
                    );
                  })}
                </div>

                <div className="w-full mt-6">
                  {activeTab === "send" && (
                    <EmailMetaApiForm
                      templates={templates}
                      groups={groups}
                      refreshSchedule={refreshSchedule}
                    />
                  )}
                  {activeTab === "schedule" && (
                    <EmailScheduleList
                      schedule={schedule}
                      hasMore={hasMore}
                      totalCount={totalCount}
                      onLoadMore={onLoadMore}
                      pageIndex={pageIndex}
                    />
                  )}{" "}
                </div>
              </div>
            </div>
          </div>
        </PageWrapper>
      </div>
    </div>
  );
};

export default EmailSendScheduleManager;
